import { render, staticRenderFns } from "./template-message.vue?vue&type=template&id=39b485f4&scoped=true&"
import script from "./template-message.vue?vue&type=script&lang=js&"
export * from "./template-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b485f4",
  null
  
)

export default component.exports